import PostListItem from "./PostListItem";

export default PostListItem;
